"use strict";

var _slicedToArray = require("/root/website/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuBusiness = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _useHeaderMenu = require("../useHeaderMenu");

var _UiComponents = require("./UiComponents");

var _HeaderTitle = require("./HeaderTitle");

var _App = require("./App");

var _core = require("@emotion/core");

var MenuBusiness = function MenuBusiness(_ref) {
  var isOpen = _ref.isOpen;

  var _ref2 = (0, _useHeaderMenu.useHeaderMenu)(),
      _ref3 = _slicedToArray(_ref2, 2),
      domain = _ref3[0].domain,
      _ref3$ = _ref3[1],
      prev = _ref3$.prev,
      close = _ref3$.close,
      handleDispatchMenuEvents = _ref3$.handleDispatchMenuEvents;

  var menuTitle = 'Empresas';
  var analyticEventAction = "inbound links | ".concat(menuTitle.toLowerCase());
  return (0, _core.jsx)(_UiComponents.Container.DropdownMenu, {
    isOpen: isOpen
  }, (0, _core.jsx)(_HeaderTitle.HeaderTitle, {
    prev: prev,
    close: close
  }, (0, _core.jsx)(_UiComponents.Typo.MenuTitle, null, menuTitle)), (0, _core.jsx)(_UiComponents.Container.DropdownLinks, null, (0, _core.jsx)(_UiComponents.Layout.Flex, {
    as: "li"
  }, (0, _core.jsx)(_UiComponents.Typo.MenuTitle, {
    weight: "lg",
    as: "a",
    href: "".concat(domain, "/beneficios"),
    onClick: function onClick() {
      return handleDispatchMenuEvents({
        action: analyticEventAction,
        label: "".concat(domain, "/beneficios")
      });
    }
  }, "Sou empresa")), (0, _core.jsx)(_UiComponents.Layout.Flex, {
    as: "li"
  }, (0, _core.jsx)(_UiComponents.Layout.Divider, null)), (0, _core.jsx)(_UiComponents.Layout.Flex, {
    as: "li"
  }, (0, _core.jsx)(_UiComponents.Typo.MenuTitle, {
    weight: "lg",
    as: "a",
    href: "".concat(domain, "/beneficios-colaborador"),
    onClick: function onClick() {
      return handleDispatchMenuEvents({
        action: analyticEventAction,
        label: "benef\xEDcios colaborador | ".concat(domain, "/beneficios-colaborador")
      });
    }
  }, "Sou colaborador")), (0, _core.jsx)(_UiComponents.Layout.Flex, {
    as: "li"
  }, (0, _core.jsx)(_UiComponents.Typo.SubItemLink, {
    as: "a",
    href: "".concat(domain, "/emprestimo/consignado-privado"),
    onClick: function onClick() {
      return handleDispatchMenuEvents({
        action: analyticEventAction,
        label: "empr\xE9stimo consignado | ".concat(domain, "/emprestimo/consignado-privado")
      });
    }
  }, "Empr\xE9stimo Consignado")), (0, _core.jsx)(_UiComponents.Layout.Flex, {
    as: "li"
  }, (0, _core.jsx)(_UiComponents.Typo.SubItemLink, {
    as: "a",
    href: "".concat(domain, "/store"),
    onClick: function onClick() {
      return handleDispatchMenuEvents({
        action: analyticEventAction,
        label: "creditas store | ".concat(domain, "/store")
      });
    }
  }, "Creditas Store"))), (0, _core.jsx)(_App.App, null));
};

exports.MenuBusiness = MenuBusiness;
process.env.NODE_ENV !== "production" ? MenuBusiness.propTypes = {
  isOpen: _propTypes.bool
} : void 0;
MenuBusiness.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MenuBusiness",
  "props": {
    "isOpen": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};